<script>
import { format, parseISO } from 'date-fns';
import * as AppConstants from '@/utils/constants';
import { getFullName, getNameAbbr, capitalize, ROLE_OPTIONS } from '@/utils';

export default {
  name: 'UtilsMixin',
  computed: {
    $pfm() {
      return { ...AppConstants };
    },
    messageTypeMap() {
      return new Map(
        this.$pfm.MESSAGE_TARGET_TYPE_OPTIONS.map((x) => [x.value, x])
      );
    },
  },
  methods: {
    getFullName,
    getNameAbbr,
    capitalize,
    getUserTypeLabel(type = '') {
      const option = ROLE_OPTIONS.find((x) => x.value === type);
      return option ? option.text : '';
    },
    formatDateTime(v, fmt = 'MM/dd/yyyy') {
      if (!v) return null;
      return format(parseISO(v), fmt);
    },
  },
};
</script>
